export default __webpack_public_path__ + "static/bts-e9f686d89f6bdcb5f7d77dc2f2ab83d3.webm";